var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"title":_vm.icon.label}},[_c('span',{class:[_vm.parent, `fa-${_vm.icon.class}`, 'vfa-icon-preview']}),_vm._v(" "),_c('div',{staticClass:"vfa-icon-info"},[_c('span',{staticClass:"class"},[_vm._v(_vm._s(_vm.icon.class))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }